import { render, staticRenderFns } from "./SalarySend.vue?vue&type=template&id=0339b32a&"
import script from "./SalarySend.vue?vue&type=script&lang=js&"
export * from "./SalarySend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports